'use client';

import usePrimeStore from '@/src/lib/state-stores/primeStore';
import { useTranslations } from 'next-intl';
import SaudiRealls, { TCountryId, TCurrency } from '@/src/components/sarComponent';
import { useCountryStore } from '@/src/lib/state-stores/currencyStore';
import { useEffect } from 'react';
import DeliveryIcon from '@/src/components/icons/DeliveryIcon';

const usePrimeStatus = () => {
  const { prime } = usePrimeStore();
  return prime?.activeSubscription && prime?.primeEnabled;
};

export const FreeDeliveryBadge = () => {
  const isPrimeActive = usePrimeStatus();
  const t = useTranslations('stores');

  if (!isPrimeActive) return null;

  return (
    <span className="border-purple flex h-6 items-center justify-center space-x-1 rounded-md border bg-[#ECE9FF] p-2 text-black lg:p-3 rtl:space-x-reverse">
      <DeliveryIcon />
      <p className="text-purple text-[10px] font-bold">{t('free')}</p>
    </span>
  );
};

export const FreeDeliveryText = ({
  deliveryFee,
  currency,
  countryId,
}: {
  deliveryFee: number;
  currency: TCurrency;
  countryId: TCountryId;
}) => {
  const isPrimeActive = usePrimeStatus();
  const t = useTranslations('stores');

  return isPrimeActive ? (
    <div className="flex gap-2">
      <span className="flex items-center gap-2 text-sm text-[#018748]">
        {t('free')} <DeliveryIcon className="h-5 w-5" />
      </span>
    </div>
  ) : (
    <div className="flex items-center gap-2 text-sm">
      <DeliveryIcon className="h-5 w-5" />
      <SaudiRealls price={deliveryFee} size="small" currency={currency} countryId={countryId} />
    </div>
  );
};
